import React from "react";
import "../components.css";

export default function ToggleButton ({label = "Label", width = "25vw", height = "25vh", offColor = "red", onColor = "green", onChange = () => {console.log("No function given.")}}: {label: string, width: string, height: string, offColor: string, onColor: string, onChange: Function}) {

    const [background, setBackground] = React.useState(offColor);
    const [state, setState] = React.useState(false);

    var tileStyle = {
        width: width,
        height: height,
    }

    function changeState() {
        setState(!state);
        onChange(state);
        setBackground(state ? offColor : onColor);
    }

    return (
        <div className="tile" style={tileStyle}>
            <div id="tilePress" onClick={() => {changeState();}} style={Object.assign({}, {backgroundColor: background})}>
                <h1>{label}</h1>
                <p>{state ? "True" : "False"}</p>
            </div>
        </div>
    )
}